import React from 'react';
import {SearchField, DataGrid, RaymanUser, UserSize, FilterMenu, Text, SmartDateLabel, SmartTagText, IconMenu} from 'components/core';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
// import clsx from 'clsx';
import {ChannelsCtx} from 'components/dataProviders/channels';
import {TagsCtx} from 'components/dataProviders/tags';
import Singletons from 'controllers/Singletons';
import {QuestionAnswer, Lock} from '@material-ui/icons'; 
import EditDialog from './edit';
import clsx from 'clsx';

const overrideStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)',
        '& .Mui-selected $idField':
        {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            '&.disabled': {
                color: theme.palette.background.default,
                backgroundColor: theme.palette.text.secondary
            }
        },
    },
    searchbox: {
        height: 40,
        width: 300
    },
    icon: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: "50%",
        padding: 8,
        width: 40,
        height: 40,
        flexBasis: 40,
        textAlign: 'center',
        lineHeight: '24px',
        alignSelf: "center",
        marginRight: 5,
        '&.locked':
        {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.secondary
        }
    },
    nameRow:
    {
        // fontWeight: 500,
        marginLeft: 15,
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    nameField: {
        display: "flex",
        flexDirection: "row",
        overflow: "hidden"
    },
    idField: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: 4,
        padding: '2px 8px',
        minWidth: 42,
        height: 24,
        textAlign: 'center',
        lineHeight: '24px',
        '&.disabled': {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.secondary
        }
    },    
    notifications: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        borderRadius: 4,
        padding: '2px',
        minWidth: 20,
        height: 20,
        marginLeft: 15,
        textAlign: 'center',
        lineHeight: '18px',
        fontSize: 13
    }
  }), {name: "RaymanDataGrid"});

  
function IDField(prchannels)
{
    const classes = overrideStyle();
    return <span className={clsx(classes.idField, prchannels.disabled? "disabled" : "")}>{prchannels.children}</span>
}

function NameField({row})
  {
      const classes = overrideStyle();
      return <div className={classes.nameField}>
                <div className={clsx(classes.icon, row.closed ? 'locked' : '')}>
                    {row.closed ? <Lock /> : <QuestionAnswer /> }
                </div>
                <Text className={classes.nameRow}>{row.name}</Text>
            </div>
  }

function NotificationBadge(prchannels)
{
    const classes = overrideStyle();
    return <span className={classes.notifications}>{prchannels.children}</span>
}

function RowMenu({row, handleEdit, dataset})
  {
      const ctx = React.useContext(ChannelsCtx);
    
      function handleArchive()
      {
          if(dataset === "open")
          {
            ctx.funcs.disable(row.channelID);
          }
          else
          {
            ctx.funcs.enable(row.channelID);
          }
      }
      let items = [
        {
            label: "Editar",
            onClick: () => handleEdit()
        },
        {
            label: dataset === "open" ? "Bloquear" : "Desbloquear",
            onClick: () => handleArchive(),
            danger: dataset === "open"
        } 
      ];
      return <>
      <IconMenu items={items} />
      </>
  }

const columns = {
    id: {
        field: 'id', 
        headerName: 'ID',
        width: 90,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
            
        }
    },
    name: { 
        field: 'name',
        headerName: 'Nombre del canal',
        flex: 1,
        renderCell: (params) => {
            return <NameField row={params.row}></NameField>
        }
    },
    tags: {
        field: 'tags',
        headerName: 'Etiquetas',
        flex: 0.5,
        renderCell: (params) => {
            return <SmartTagText tagIDs={params.value} />
        }
    },
    lastMessage: {
        field: 'lastMessage',
        headerName: 'Ult. mensaje',
        width: 170,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            {false && params.row.notifications ? <NotificationBadge>{params.row.notifications}</NotificationBadge> : null}
            </>;
        }
    },
    closed: {
        field: 'closeDatetime',
        headerName: 'Cerrado',
        width: 170,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            </>;
        }
    }
}

const collapsedColumns = [columns.name, columns.tags, columns.lastMessage];
const extendedColumns = [columns.name, columns.tags, columns.lastMessage];

const usersFilter = [
    {value: true, text: "Ver sólo mis canales", overrideLabel: "Mis canales"},
    {value: false, text: "Ver todos los canales", overrideLabel: "Todos los canales"}
]


export default function ChannelsList({onRowSelected = () => {}, collapsed = false})
{
    const classes = overrideStyle();
    const channelsCtx = React.useContext(ChannelsCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const [data, setData] = React.useState(channelsCtx.data.array);
    const [filters, setFilters] = React.useState({text: '', tags: [], user: false});
    const [gridColumns, setGridColumns] = React.useState([]);
    const [userFilterElem, setUserFilterElem] = React.useState(null);
    const [filterTags, setFilterTags] = React.useState([]);
    const [editDialogState, setEditDialogState] = React.useState({open: false, channelID: null});

    const menuColumn = React.useMemo(() => ({
        field: 'menu',
        headerName: ' ',
        width: 40,
        align: 'center',
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return <RowMenu row={params.row} handleEdit={() => setEditDialogState({open: true, channelID: params.row.channelID})} />
        }
    }), []);

    let searchTimeout = 0;

    React.useEffect(function filterData(){
        
        let tmpData = [...channelsCtx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            if(filters.tags.length > 0) result &= value.tags.some(r => filters.tags.includes(r));            
            if(filters.user) result &= (value.users.includes(filters.user));
            // result &= (value.closed === (dataset === "closed"));
            return result;
        });

        setData(tmpData);
    }, [channelsCtx, filters]);

    React.useEffect(function initializeFilterTags() {
        let tags = [];
        tagsCtx.data.array.forEach((item) => tags.push({value: item.tagID, text: item.name}));

        setFilterTags(tags);
    }, [tagsCtx]);

    React.useEffect(function handleColumns(){
        let gridCols = collapsed ? [...collapsedColumns] : [...extendedColumns];
        // TODO: Añadir menu de editar ?
        //if(Singletons.userProfiles.admin || Singletons.userProfiles.expert) gridCols.push(menuColumn);

        // if(dataset === "closed") gridCols.splice(gridCols.length - 2, 1, columns.closed);
        setGridColumns(gridCols);
    }, [collapsed, menuColumn]);

    const handleSelectRow = (row) =>
    {
        onRowSelected(row);
    }

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    const handleTagsChange = React.useCallback((tags) => {
        let tmpFilters = {...filters};
        tmpFilters.tags = tags;
        
        if(tmpFilters.tags.join(",") !== filters.tags.join(","))
        {
            setFilters(tmpFilters);
        }
        
    }, [filters]);

    const handleUsersChange = React.useCallback((users) => {
        let tmpFilters = {...filters};
        if(users[0]) tmpFilters.user = Singletons.currentUser.userID;
        else tmpFilters.user = false;
        if(tmpFilters.user !== filters.user)
        {
            setFilters(tmpFilters);
        }
    }, [filters]);

    React.useEffect(function createUsersFilter() {

        let disabled = true;
        let preselected = 0;

        if(Singletons.currentUser.profiles.length > 1)
        {
            if(Singletons.currentUser.profiles.indexOf("administrators") !== -1)
            {
                disabled = false;
            }
        }
        else
        {
            if(Singletons.currentUser.profiles[0] === "administrators")
            {
                preselected = 1;
            }
        }
        setUserFilterElem(<Grid item><FilterMenu type="radio" disabled={disabled} selectedIndexes = {[preselected]} items={usersFilter} onChange={handleUsersChange}/></Grid>);
    }, [handleUsersChange]);

    function handleEditDialogClose()
    {
        setEditDialogState({open: false, channelID: null});
    }

    let columnSorting = [];
    columnSorting.push({
            field: 'lastMessage',
            sort: 'desc'
        });
    
    return <>
        <EditDialog open={editDialogState.open} onClose={()=>handleEditDialogClose()} channelID={editDialogState.channelID} />
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                    <Grid item><Text>Filtros:</Text> </Grid>
                    <Grid item><FilterMenu label={"Etiquetas"} items={filterTags} onChange={handleTagsChange}/></Grid>
                    {userFilterElem}
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        onRowSelected = {(row) => handleSelectRow(row.data)}
        loading={channelsCtx.loading}
        density="comfortable"
        className={classes.datagrid}
        sortModel={columnSorting}
        />
    </>
}